import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { Filter } from 'Types/FilterTypes';
import styled from 'styled-components';
import { driver } from 'Utils/utilsStyle';
import { allValueInKeyOfArrayExists } from '../../../Utils/UtilityFunctions';
import AlertsTriggersCheckBox from './AlertsTriggersCheckBox';
import LineSkeleton from '../../common/skeleton/LineSkeleton';

type Props = {
  onClickUnSelect: (a: boolean) => void
  load: boolean
  filters: Filter[]
  onCheckedChange: (a: boolean, b: string) => void
};

export const NoFilterText = styled.p`
  color: ${driver} !important;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  font-family: Roboto;
  letter-spacing: -0.4px;
  `;

const AlertsTriggersPanel = function AlertsTriggersPanel(props: Props) {
  const {
    onClickUnSelect,
    onCheckedChange,
    load,
    filters,
  } = props;
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [isNoFilterSelected, setIsNoFilterSelected] = useState<boolean>(false);

  useEffect(() => {
    setIsNoFilterSelected(allValueInKeyOfArrayExists(filters, 'isSelected', false));
    setSelectAll(allValueInKeyOfArrayExists(filters, 'isSelected', true));
  }, [filters]);

  useEffect(() => {
    if (filters.length === 0) {
      setIsNoFilterSelected(false);
    }
  }, []);

  const selection = () => {
    onClickUnSelect(!selectAll);
    setSelectAll(!selectAll);
  };
  return (
    <div className="triggers-checkbox-panel">
      <div className="heading-panel">
        <h6 className="head">Sales Triggers:</h6>
        <span className="unselect" onClick={selection} onKeyPress={selection} tabIndex={0} role="button" aria-label="unselect all">{selectAll ? 'unselect all' : 'select all'}</span>
      </div>
      {isNoFilterSelected && <NoFilterText>Please Select One Filter at Least</NoFilterText>}
      <div className="trigger-checkbox-area">
        <div className="grid-checkbox-wrapper">
          {load ? (
            <Row>
              <Col span={12}>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(() => <LineSkeleton />)}

              </Col>
              <Col span={12}>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => <LineSkeleton />)}

              </Col>
            </Row>
          )
            : (
              <Row>
                <Col span={12}>
                  {filters.slice(0, Math.ceil(filters.length / 2)).map((filter: Filter) => (
                    <AlertsTriggersCheckBox
                      id={filter.filterId}
                      title={filter.filterName}
                      color={filter.filterColor}
                      checked={filter.isSelected}
                      onCheckedChange={onCheckedChange}
                    />
                  ))}
                </Col>
                <Col span={12}>
                  {filters
                    .slice(Math.ceil(filters.length / 2), filters.length)
                    .map((filter: Filter) => (
                      <AlertsTriggersCheckBox
                        id={filter.filterId}
                        title={filter.filterName}
                        color={filter.filterColor}
                        checked={filter.isSelected}
                        onCheckedChange={onCheckedChange}
                      />
                    ))}

                </Col>
              </Row>
            )}

        </div>
      </div>
    </div>
  );
};

export default AlertsTriggersPanel;
